import { render } from "./updatetip.vue?vue&type=template&id=0ca5c92e"
import script from "./updatetip.vue?vue&type=script&lang=js"
export * from "./updatetip.vue?vue&type=script&lang=js"

import "./updatetip.vue?vue&type=style&index=0&id=0ca5c92e&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__